import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import CustomizeInterface from './features/napkin/CustomizeInterface';
import CheckoutForm from './features/checkout/CheckoutForm';
import PaymentProcessor from './features/payment/PaymentProcessor';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="app-container">
          <header className="app-header">
            <h1>FESTIVE OCCASIONS</h1>
            <p>Napkin Customizer</p>
          </header>
          <Routes>
            <Route path="/" element={<CustomizeInterface />} />
            <Route path="/checkout" element={<CheckoutForm />} />
            <Route path="/payment" element={<PaymentProcessor />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
